export default __webpack_public_path__ + "assets/1bf0ad3dce379bef08bc2878ed074e28.png";